import { render } from "./TemporaryWorkDetail.vue?vue&type=template&id=ddaf7ff8&scoped=true"
import script from "./TemporaryWorkDetail.vue?vue&type=script&lang=js"
export * from "./TemporaryWorkDetail.vue?vue&type=script&lang=js"

import "./TemporaryWorkDetail.vue?vue&type=style&index=0&id=ddaf7ff8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddaf7ff8"]])

export default __exports__